// --- Core ---
import {configureStore} from '@reduxjs/toolkit';
import reducer from "./reducers";
// eslint-disable-next-line no-restricted-imports
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      isSerializable: (value: unknown) => {
        if (value instanceof Date) {
          return true;
        }

        return true;
      }
    }
  })
});

type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;
type AsyncThunkConfig = {
  state: RootState
};

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export {AsyncThunkConfig, RootState, store, useAppSelector, useAppDispatch};
